import { c as _c } from "react/compiler-runtime";
import { IcoSettings16 } from '@onefootprint/icons';
import type { TemplateInputProps } from '@onefootprint/ui';
import { Divider, Form, InlineAlert } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SettingsSection from '../../shared/settings-section';
import type { CompleteFormData } from '../complete-node.types';
import { willRenderCta } from '../will-render-cta';
import { AutoAdvanceFields } from './auto-advance-fields';
import type { PanelState } from './complete-node-form/use-panel-state';
import { CtaFields } from './cta-fields';
type CompleteNodeFieldsProps = {
  autocompleteItems: TemplateInputProps['autocompleteItems'];
  canEdit: boolean;
  panel: PanelState;
};
export const CompleteNodeFields = t0 => {
  const $ = _c(66);
  const {
    autocompleteItems,
    canEdit,
    panel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "completeNode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const form = useFormContext();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["ctaLabel", "ctaUrl", "ctaTarget", "secondaryCtaUrl", "secondaryCtaTarget", "autoAdvance"];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== form.control) {
    t3 = {
      control: form.control,
      name: t2
    };
    $[2] = form.control;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [ctaLabel, ctaUrl, ctaTarget, secondaryCtaUrl, secondaryCtaTarget, autoAdvance] = useWatch(t3);
  const hasSameTabLink = !!ctaUrl && ctaTarget === "same_tab" || !!ctaUrl && !!secondaryCtaUrl && secondaryCtaTarget === "same_tab";
  let t4;
  if ($[4] !== autoAdvance || $[5] !== ctaLabel || $[6] !== ctaUrl || $[7] !== t) {
    t4 = !willRenderCta(ctaLabel, ctaUrl) && !autoAdvance && <InlineAlert variant="warning">{t(_temp)}</InlineAlert>;
    $[4] = autoAdvance;
    $[5] = ctaLabel;
    $[6] = ctaUrl;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp2);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = panel.openSections.basic;
  let t7;
  if ($[11] !== panel) {
    t7 = open => panel.setSectionOpen("basic", open);
    $[11] = panel;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp3);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t(_temp4);
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t(_temp5);
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = {
      required: t10
    };
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== autocompleteItems || $[22] !== t11 || $[23] !== t8 || $[24] !== t9) {
    t12 = <Form.TemplateInput name="header" label={t8} placeholder={t9} size="compact" autocompleteItems={autocompleteItems} rules={t11} />;
    $[21] = autocompleteItems;
    $[22] = t11;
    $[23] = t8;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t(_temp6);
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t(_temp7);
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== autocompleteItems || $[31] !== t13 || $[32] !== t14) {
    t15 = <Form.TemplateInput name="subheader" label={t13} placeholder={t14} size="compact" autocompleteItems={autocompleteItems} />;
    $[30] = autocompleteItems;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t(_temp8);
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t(_temp9);
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== autocompleteItems || $[39] !== t16 || $[40] !== t17) {
    t18 = <Form.TemplateTextarea name="content" label={t16} placeholder={t17} size="compact" autocompleteItems={autocompleteItems} />;
    $[38] = autocompleteItems;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== panel.openSections.basic || $[43] !== t12 || $[44] !== t15 || $[45] !== t18 || $[46] !== t5 || $[47] !== t7) {
    t19 = <SettingsSection title={t5} icon={IcoSettings16} keepMounted={true} open={t6} onOpenChange={t7}>{t12}{t15}{t18}</SettingsSection>;
    $[42] = panel.openSections.basic;
    $[43] = t12;
    $[44] = t15;
    $[45] = t18;
    $[46] = t5;
    $[47] = t7;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Divider />;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== autocompleteItems || $[51] !== canEdit || $[52] !== panel) {
    t21 = <CtaFields autocompleteItems={autocompleteItems} canEdit={canEdit} panel={panel} />;
    $[50] = autocompleteItems;
    $[51] = canEdit;
    $[52] = panel;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Divider />;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== canEdit || $[56] !== hasSameTabLink || $[57] !== panel) {
    t23 = <AutoAdvanceFields canEdit={canEdit} hasSameTabLink={hasSameTabLink} panel={panel} />;
    $[55] = canEdit;
    $[56] = hasSameTabLink;
    $[57] = panel;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== t19 || $[60] !== t21 || $[61] !== t23) {
    t24 = <div className="flex flex-col bg-primary border border-tertiary rounded">{t19}{t20}{t21}{t22}{t23}</div>;
    $[59] = t19;
    $[60] = t21;
    $[61] = t23;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] !== t24 || $[64] !== t4) {
    t25 = <>{t4}{t24}</>;
    $[63] = t24;
    $[64] = t4;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  return t25;
};
function _temp($) {
  return $.sdkWarning;
}
function _temp2($_0) {
  return $_0.basic.title;
}
function _temp3($_1) {
  return $_1.header.label;
}
function _temp4($_2) {
  return $_2.header.placeholder;
}
function _temp5($_3) {
  return $_3.header.required;
}
function _temp6($_4) {
  return $_4.subheader.label;
}
function _temp7($_5) {
  return $_5.subheader.placeholder;
}
function _temp8($_6) {
  return $_6.content.label;
}
function _temp9($_7) {
  return $_7.content.placeholder;
}